import React, { Component } from 'react'
import { CLOUDS } from '../utils/colors'


class Image extends Component {

    render() {
        return (
            <img src={this.props.source} style={{maxHeight: `${this.props.height}`, width: 'auto', borderRadius: '100%', border: `solid 12px ${CLOUDS}`}} alt='me' />
        )
    }

}


export default Image



// WEBPACK FOOTER //
// ./src/components/image.js